import React, { useEffect, useState } from "react";
import { Row, Col, Card, Spin, Space, Typography } from "antd";
import { Link } from "react-router-dom";
import Title from "antd/es/typography/Title";
import { apiCaller } from "src/util/apiCaller";
import {
  UserOutlined,
  CalendarOutlined,
  FolderOpenOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

const { Text, Paragraph } = Typography;

const GallerySliderHome: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [documents, setDocuments] = useState<DocumentData[]>([]);

  const fetchHistoricalDocuments = async () => {
    setLoading(true);
    try {
      const response = await apiCaller({
        url: `/apipublic/tulieuhienthis?ishinhanh=true&page=1&size=4&properties_sort=id&type_sort=desc`,
        method: 'GET',
      });

      if (response?.data) {
        const { content } = response.data;
        const formattedDocuments = content.map((doc: any) => ({
          idTulieu: doc.id,
          anhDaiDien: doc.anhDaiDien,
          tenTuLieu: doc.tenTuLieu,
          moTa: doc.moTa,
          tacGia: doc.tacGia,
          historicalPeriod: doc.loaiTuLieu.tenLoaiTuLieu || "",
          ngayDang: doc.ngayDang,
          culturalType: doc.culturalType,
          productType: doc.productType,
          loaiTuLieu: doc.loaiTuLieu,
        }));

        setDocuments(formattedDocuments);
      }
    } catch (error) {
      console.error("Error fetching documents:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistoricalDocuments();
  }, []);

  if (loading && documents.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ marginBottom: "20px" }} className="QTI-list-detail-container">
      <Title level={2} className="QTI-slider-home-title">
        Hình ảnh
        <div
          style={{
            textAlign: "right",
            marginTop: 18,
            fontSize: 13,
            fontStyle: "italic",
            color: "#1677ff",
          }}
        >
          <Link to={`/trang-chu/hinh-anh`} onClick={() => localStorage.setItem("currentMenuKey", "hinh-anh")}>
            Xem thêm <DoubleRightOutlined />
          </Link>
        </div>
      </Title>
      <Row gutter={[16, 16]}>
        {documents.map((document) => (
          <Col key={document.idTulieu} xs={24} sm={12} md={6}>
            <Link 
              to={`/trang-chu/hinh-anh/${document.idTulieu}/chi-tiet`} 
              onClick={() => localStorage.setItem("currentMenuKey", "hinh-anh")}
            >
              <Card
                className="QTI-slider-home-card"
                hoverable
                style={{ padding: "12px"}}
                cover={
                  <div className="QTI-slider-home-card__cover">
                    <img alt={document.tenTuLieu} src={document.anhDaiDien} />
                  </div>
                }
              >
                <Card.Meta
                  className="card-meta-custom"
                  title={document.tenTuLieu}
                  description={
                    <Space
                      size={16}
                      style={{ display: "flex", flexWrap: "wrap", justifyContent: 'space-around' }}
                    >
                      {document.tacGia && (
                        <Text strong style={{ fontSize: "12px" }}>
                          <UserOutlined />
                           {document.tacGia.length > 10 ? `${document.tacGia.slice(0, 10)}...` : document.tacGia}
                        </Text>
                      )}
                      {document.ngayDang && (
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          <CalendarOutlined />{" "}
                          {new Date(document.ngayDang).toLocaleDateString(
                            "vi-VN"
                          )}
                        </Text>
                      )}
                      {document.historicalPeriod && (
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          <FolderOpenOutlined /> {document.historicalPeriod}
                        </Text>
                      )}
                    </Space>
                  }
                />
                <Paragraph type="secondary" className="QTI-mota-trang-chu">
                  {document.moTa}
                </Paragraph>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
};

interface DocumentData {
  idTulieu: string;
  anhDaiDien: string;
  tenTuLieu: string;
  moTa: string;
  tacGia?: string;
  culturalType?: string;
  productType?: string;
  historicalPeriod?: string;
  ngayDang?: string;
  loaiTuLieu?: {
    tenLoaiTuLieu: string;
  };
}

export default GallerySliderHome;
